'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _feedItemContainer = require('../feed-item-container');

var _feedItemContainer2 = _interopRequireDefault(_feedItemContainer);

var _feedItemMessage = require('../feed-item-message');

var _feedItemMessage2 = _interopRequireDefault(_feedItemMessage);

var _propTypes = require('../../../shared/prop-types');

var _imageSize = require('../../../shared/image-size');

var _imageSize2 = _interopRequireDefault(_imageSize);

var _FollowUserLink = require('../FollowUserLink');

var _FollowUserLink2 = _interopRequireDefault(_FollowUserLink);

var _Uniform = require('../../Uniform');

require('./image-feed-item.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImageFeedItem = function (_PureComponent) {
  _inherits(ImageFeedItem, _PureComponent);

  function ImageFeedItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ImageFeedItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageFeedItem.__proto__ || Object.getPrototypeOf(ImageFeedItem)).call.apply(_ref, [this].concat(args))), _this), _this.renderImage = function (image, index) {
      var relatedFeedUser = void 0;
      if (image.relatedFeedUserId) {
        relatedFeedUser = _this.props.feedUsers.find(function (user) {
          return user.feedUserId.relatedId === image.relatedFeedUserId.relatedId && user.feedUserId.type === image.relatedFeedUserId.type;
        });
      }

      return _react2.default.createElement(
        'div',
        { key: index },
        _react2.default.createElement(
          _Uniform.CardMedia,
          null,
          _react2.default.createElement(
            'div',
            { className: 'media-container' },
            _react2.default.createElement(
              'div',
              { className: 'cover-image' },
              _react2.default.createElement('img', { src: _this.getImageUrl(image) }),
              _react2.default.createElement(
                'div',
                { className: 'content-description' },
                image.title ? _react2.default.createElement(
                  'h5',
                  { className: 'title' },
                  image.title
                ) : null,
                image.subtitle ? _react2.default.createElement(
                  'p',
                  { className: 'subtitle' },
                  image.subtitle
                ) : null
              ),
              _react2.default.createElement('div', { className: 'image-overlay border-only' }),
              image.title ? _react2.default.createElement('div', { className: 'image-overlay' }) : null
            )
          )
        ),
        image.includeFollowButton && relatedFeedUser && _react2.default.createElement(_FollowUserLink2.default, {
          currentUserId: _this.props.currentUserId,
          feedUser: relatedFeedUser,
          onProfileClick: _this.props.onProfileClick
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ImageFeedItem, [{
    key: 'getImageUrl',
    value: function getImageUrl(image) {
      var imageFiles = image.imageFiles || [];
      var imageFile = imageFiles.find(function (i) {
        return i.size === _imageSize2.default.Retina;
      }) || imageFiles.find(function (i) {
        return i.size === _imageSize2.default.Normal;
      }) || imageFiles.find(function (i) {
        return i.size === _imageSize2.default.Full;
      }) || imageFiles.find(function (i) {
        return i.size === _imageSize2.default.Thumbnail;
      }) || {};

      return imageFile.url;
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.content.item;

      return _react2.default.createElement(
        _feedItemContainer2.default,
        _extends({ className: 'shared-image',
          date: this.props.content.dateCreated,
          title: item.action
        }, this.props),
        _react2.default.createElement(
          'div',
          { className: 'feedattachments' },
          _react2.default.createElement(
            'div',
            { className: 'feedattachments-wrapper' },
            _react2.default.createElement(
              'div',
              { className: 'content' },
              item.description && _react2.default.createElement(_feedItemMessage2.default, { description: item.description }),
              item.images.map(this.renderImage)
            )
          )
        ),
        item.linkTitle && _react2.default.createElement(
          'div',
          {
            className: 'feeditem-link uni-btn--primary--minimal uni-btn--medium uni-margin--half--top',
            onClick: this.props.onFeedLinkClick
          },
          _react2.default.createElement(
            'a',
            { href: item.linkUrl },
            _react2.default.createElement(
              'span',
              null,
              item.linkTitle
            )
          )
        )
      );
    }
  }]);

  return ImageFeedItem;
}(_react.PureComponent);

ImageFeedItem.propTypes = {
  author: _react.PropTypes.object.isRequired,
  content: _react.PropTypes.shape({
    dateCreated: _react.PropTypes.string.isRequired,
    item: _react.PropTypes.shape({
      description: _react.PropTypes.string,
      images: _react.PropTypes.arrayOf(_react.PropTypes.shape({
        imageFiles: _react.PropTypes.arrayOf(_react.PropTypes.shape({
          size: _react.PropTypes.number.isRequired,
          url: _react.PropTypes.string.isRequired,
          height: _react.PropTypes.number,
          width: _react.PropTypes.number
        })).isRequired,
        linkTitle: _react.PropTypes.string,
        linkUrl: _react.PropTypes.string
      })).isRequired
    }).isRequired
  }).isRequired,
  currentUserId: _react.PropTypes.string,
  feedUsers: _react.PropTypes.arrayOf(_propTypes.FeedUser),
  includeFollowButton: _react.PropTypes.bool,
  onProfileClick: _react.PropTypes.func,
  onFeedLinkClick: _react.PropTypes.func,
  addReactionButton: _react.PropTypes.element,
  reactionComponent: _react.PropTypes.element
};
exports.default = ImageFeedItem;